<template lang="pug">
div.box(v-if="!fuel_enabled")
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
import Feature from '@js/plugins/feature';

const TableName = 'VUETABLE_CATEGORY_SALES';
export default {
    data: function() {
        return {
            tableName: TableName,
            columns: [
                'code',
                'name',
                this.trans('product.category'),
                'total_quantity',
                'total_net_sales',
                'total_cost',
                'total_margin',
            ],
            options: {
                skin: 'table m-b-0 b-b',
                texts: {
                    title: Feature.hasFeature('fuel')
                        ? 'Loyalty Category'
                        : 'Product Sales by Category',
                    description: Feature.hasFeature('fuel')
                        ? 'Shows product sales by loyalty category'
                        : 'Shows product sales by category',
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                headings: {
                    name: 'Product',
                    total_net_sales: 'Total net sales',
                    [this.trans('product.category')]: this.trans('tag.title'),
                },
                orderBy: {
                    ascending: true,
                    column: 'name',
                },
                pdf_url: Laroute.route(
                    'franchise.report.non_fuel.item.export_category_sales',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.non_fuel.item.export_category_sales',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.non_fuel.item.export_category_sales',
                    { type: 'XLSX' },
                ),
                responseAdapter(res) {
                    const data = res.data.data;
                    const grouped = _.groupBy(
                        data,
                        this.trans('product.category'),
                    );
                    const results = [];

                    _.forEach(grouped, (rows, categoryName) => {
                        results.push({
                            code: categoryName,
                            parent: true,
                        });

                        rows.forEach(row => {
                            row.parent = false;
                            results.push(row);
                        });
                    });

                    return {
                        data: results,
                        count: res.data.count,
                    };
                },
                rowClassCallback(row) {
                    if (row.parent) {
                        return 'table-row-divider';
                    }

                    return null;
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route(
                'franchise.report.non_fuel.item.category_sales',
            );
        },

        fuel_enabled() {
            return Feature.hasFeature('fuel');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable-category-sales.vue